import { createVanIconComponent } from "./van"

const BillOutlined = createVanIconComponent("bill-o")
export default BillOutlined
